import {
  COMBINED_ENTRY_PAGE_LOADED,
  COMBINED_RESULTS_LOADED,
} from '@web-platform/shared-universal-constants/src/redux/actions/render';

import { VIEWED_TRAVELLER_SELECTOR } from '../../../../actions/user';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { UIState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/ui';

export type { UIState };

const getInitialState = () => ({
  viewedTravellerSelector: false,
});

const ui = (state: UIState = getInitialState(), action: Action): UIState => {
  switch (action.type) {
    /* COMBINED_RESULTS_LOADED and COMBINED_ENTRY_PAGE_LOADED set viewedTravellerSelector to true here
       to handle when travellers go straight to Combined Results via URL, and then go back to homepage.
       Without this, they have to open the Traveller Selector before being able to search. They cannot
       perform a search directly by clicking the "Search" button. */
    case VIEWED_TRAVELLER_SELECTOR:
    case COMBINED_RESULTS_LOADED:
    case COMBINED_ENTRY_PAGE_LOADED: {
      return { ...state, viewedTravellerSelector: true };
    }

    default:
      return state;
  }
};

export default ui;
export const get = (state: UIState): UIState => state;
